import request from '../request'

export const getAnalyticsCharts = () => request.get('setting/analytics-chart').then((res) => res)

export const createAnalyticsChart = (data) => request.post('setting/analytics-chart', data).then((res) => res)

export const updateAnalyticsChart = (id, data) =>
  request.put(`setting/analytics-chart/${id}`, data).then((res) => res)

export const deleteAnalyticsChart = (id) => request.delete(`setting/analytics-chart/${id}`).then((res) => res)

// MF-554 — the whole Analytics menu order at once: the buttons the user sees, in the new order.
export const reorderAnalyticsCharts = (ids) =>
  request.put('setting/analytics-chart/order', { ids }).then((res) => res)
